import React from 'react';
import TravelInfo from "@SearchResults/features/travelInfo/components/TravelInfo";
import MobileAppTitle from "@SearchResults/components/HeadingContent/Mobile/MobileAppTitle";
import Row from "@Containers/components/Row";
import BackButton from "@Routing/components/BackButton";
import Timer from "@CheckOrder/components/Sidebar/Timer";
import RouteType from "@Route/types/Route.type";
import useResolvePreviousRouteFromCheckOrderData from "@CheckOrder/hooks/useResolvePreviousRouteFromCheckOrderData";
import useIsMobile from "@Hooks/selector/useIsMobile";
import {Colors} from "@Styles/Colors.style";
import TripDetailsContainer from "@CheckOrder/components/Title/TripDetailsContainer";

function CheckOrderTitle({singleRoute}: { singleRoute: RouteType }) {
    const {
        travelInfo: {
            departureStation,
            destinationStation,
        },
    } = singleRoute

    const isMobile = useIsMobile()
    const {goBack} = useResolvePreviousRouteFromCheckOrderData()

    return (
        <div className="gb--travel-info" style={isMobile ? {position: 'unset', background: Colors.primaryColor, paddingBottom: '.5rem'} : {}}>
            {isMobile ? (
                <>
                    <MobileAppTitle
                        backClick={goBack}
                        subtitleComponent={<Timer/>}
                    >
                        <TravelInfo
                            departureStationName={departureStation.cityName}
                            destinationStationName={destinationStation.cityName}
                            date={departureStation.departureDate}
                        />
                    </MobileAppTitle>
                    {!singleRoute.isIntermodalRoute && !singleRoute.isApiIntermodalRoute && (
                        <TripDetailsContainer/>
                    )}
                </>
            ) : (
                <Row justify className="gb--travel-info__wrapper">
                    <Row>
                        <BackButton
                            backClick={goBack}
                        />
                        <TravelInfo
                            departureStationName={departureStation.cityName}
                            destinationStationName={destinationStation.cityName}
                            date={departureStation.departureDate}
                        />
                    </Row>
                    <Timer/>
                </Row>
            )}
        </div>
    )
}

export default CheckOrderTitle;